<template>
	<div class="form-group">
		<label for="password">{{ $t(title) }} <span v-if='required' class="required-field">*</span></label>
		<!-- <div v-if='show_strength' style='vertical-align: middle'>
			<div :style='{display: "inline-block", width: "10%", height: "10px", backgroundColor: passwordfield.length ? (score < 1 ? "red" : "lightgreen") : "grey"}'></div>
			<div :style='{display: "inline-block", width: "10%", height: "10px", backgroundColor: score > 0 ? "lightgreen" : "grey"}'></div>
			<div :style='{display: "inline-block", width: "10%", height: "10px", backgroundColor: score > 1 ? "lightgreen" : "grey"}'></div>
			<div :style='{display: "inline-block", width: "10%", height: "10px", backgroundColor: score > 2 ? "lightgreen" : "grey"}'></div>
			<div :style='{display: "inline-block", width: "10%", height: "10px", backgroundColor: score > 3 ? "lightgreen" : "grey"}'></div>
			<div :style='{display: "inline-block"}' v-text='getScoreText()'></div>
		</div> -->

		
		<div class="input-group">
			<input name='password' ref='passwordField' class="form-control" :type="passwordFieldType" v-model='password' :required='required' id="password">
			<div class="input-group-append">
				<button ref='showhide' v-on:click.prevent="switchVisibility" class="input-group-text" type="button">{{show}}</button>
			</div>
		</div>
		
		<inline-error :type='password_error_name'></inline-error>
		<ul  v-if='show_strength' >
			<li v-for="(rule, name) in passwordValidationRules" :key="name" :style='testRuleClass(rule, password) ? {color: "darkgreen", "font-weight": "550"} : {}''>
				{{ rule.description }} <i v-if='testRuleClass(rule, password)' class="fa fa-sm fa-solid fa-check"></i>
			</li>
		</ul>
        <password-strength-info></password-strength-info>
	</div>
</template>

<script>
	
	export default {
		props: {
			"passwordfield": {},
            "email": {},
            "forenames": {},
            "surname": {},
            "errors": {},
            "show_strength": {
                default: true
            },
            "title": {
                default: Vue.i18n.translate('translations.password')
            },
            "required": {
                default: true
            },
            "password_error_name": {
                default: "password"
            }
        },
		data: function(){
			return {
				passwordFieldType: 'password',
	            show: 'show',
	            score: 0,
	            previouslyTested: {},
				password: "",
				passwordValidationRules: {
					size: {
						regex: /^.{8,}$/,
						description: 'Is at least 8 characters long'
					},
					upper: {
						regex: /[A-Z]/,
						description: 'Contains at least one upper case character'
					},
					lower: {
						regex: /[a-z]/,
						description: 'Contains at least one lower case character'
					},
					number: {
						regex: /[0-9]/,
						description: 'Contains at least one number'
					},
					symbol: {
						regex: /[$^*.[\]{}()?"!@#%&/\,><':;|_~`=+-]/,
						description: 'Contains at least one symbol ($^*.[\]{}()?"!@#%&/\,><\':;|_~`=+-)'
					}
				}
			};
		},
		computed: {
		},
		watch: {
	        'password' : function(){
                this.$emit('update:passwordfield', this.password);
                if(this.show_strength) {
                    this.isValidPassword(this.password);
                }
	        },
            // 'passwordfield' : function(){
            //     this.password = this.passwordfield;    
	        // }
	    },
		mounted() {
			this.password = this.passwordfield;
		},
		methods: {
			switchVisibility() {
	            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
	            this.show = this.show === 'show' ? 'hide' : 'show';
	           // this.$refs.passwordField.focus();
	        },
			isValidPassword(password) {
				let valid = true;
				Object.keys(this.passwordValidationRules).forEach(
					rule => (valid = valid && this.passwordValidationRules[rule].regex.test(password))
				);

				return valid;
			},
			testRuleClass(rule, password) {
				return rule.regex.test(password);
			},
			testStrengthZxcvbn(password) {
	            if(this.$parent.errors["password"]) {
	                this.$parent.errors["password"] = [];
	            }
	            if(password.length) {
	                if(typeof this.previouslyTested[password] != "undefined") {
	                    this.score = this.previouslyTested[password];
	                }
	                else {
                        var data = {
                            "password": password
                        };
                        if(this.email) {
                            data["email"] = this.email;
                        }
                        if(this.forenames || this.surname) {
                            data["name"] = "" + this.forenames + " " + this.surname;
                        }
	                    axios.post('/api/v0/auth/strength', data).then((res) => {
	                        this.score = res.data.score;
	                        this.previouslyTested[password] = res.data.score;
							//console.log("Score: " + res.data.score);
	                    }).catch((error) => {
	                        //this.handleError(error, "create");
	                    });
	                }
	            }
	            else {
	                this.score = 0;
	            }
	        },
	        getScoreText() {
	            if(this.passwordfield.length == 0) {
	                return "";
	            }
	            switch(parseInt(this.score)) {
	                case 0: return "Very Weak"; break;
	                case 1: return "Weak"; break;
	                case 2: return "Moderate"; break;
	                case 3: return "Strong"; break;
	                case 4: return "Very Strong"; break;
	            }
	        }
		}
    }
</script>
